define(function (require) {
    "use strict";

    var LE = require("app");
    var CONST = require("const");
    var template = require("web-agent-templates/managerParticipantsBubbleItemView.tmpl");

    var ManagerParticipantsBubbleItemView = {};

    LE.module(CONST.MODULES.AGENT, function (LEWebAgent, LE, Backbone, Marionette, $, _) {
        ManagerParticipantsBubbleItemView = Marionette.ItemView.extend({

            className: 'manager-participant-item',
            template: template,

            customTemplateHelpers: function () {
                var unreadIconClassName;
                if (this.model.get('managerUnreadCount')) {
                    unreadIconClassName = 'unread_icon';
                } else {
                    unreadIconClassName = 'hide';
                }
                return {
                    unreadIconClassName: unreadIconClassName
                };
            }
        });
    });

    return ManagerParticipantsBubbleItemView;

});
